import barba from '@barba/core'
import intlTelInput from 'intl-tel-input'
import 'intl-tel-input/build/css/intlTelInput.css'
import { enableBodyScroll, disableBodyScroll } from 'body-scroll-lock'

import html5Validation from './html5-validation'
import customInputs from './custom-inputs'
import lazyRecaptcha from './lazy-recaptcha'
import animatedFormSubmission from './animated-form-submission'

let onSuccess
const afterCaptcha = form =>
  animatedFormSubmission(form).then(({ error, response, success }) => {
    if (response.ok) {
      success()
      if ('redirect' in form.dataset) {
        barba.go(form.dataset.redirect)
      }
      if (typeof onSuccess === 'function') {
        onSuccess()
      }
    } else {
      response.json().then(json => {
        const messages = form.querySelector('[data-form-messages]')
        if (messages) {
          messages.scrollIntoView()
        }

        const errorContainer = form.querySelector('.form-animation__error')
        if (errorContainer) {
          errorContainer.textContent = json.message
        }

        error()
      })
    }
  })

const captchaObserver = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      const callback =
        'animatedSubmission' in entry.target.dataset
          ? afterCaptcha
          : form => form.submit()
      lazyRecaptcha.protectForm(entry.target, callback)
      captchaObserver.unobserve(entry.target)
    }
  })
})

export default (page, options = {}) => {
  if (!options.skipCustomization) {
    customInputs(page)
  }

  // validate inputs, call after customInputs because flatpickr creates extra hidden input
  html5Validation(page, options.validation)

  captchaObserver.disconnect()
  page
    .querySelectorAll('[data-recaptcha-protected]')
    .forEach(form => captchaObserver.observe(form))

  page
    .querySelectorAll(
      '[data-animated-submission]:not([data-recaptcha-protected])'
    )
    .forEach(el => {
      el.addEventListener('submit', e => {
        e.preventDefault()
        afterCaptcha(el)
      })
    })

  if (options.onSuccess) {
    onSuccess = options.onSuccess
  }

  page.querySelectorAll('.input-field[type="tel"]').forEach(input => {
    if (input.closest('.iti')) return
    const iti = intlTelInput(input, {
      initialCountry: 'auto',
      nationalMode: false,
      preferredCountries: [],
    })
    input.addEventListener('open:countrydropdown', () =>
      disableBodyScroll(iti.countryList)
    )
    input.addEventListener('close:countrydropdown', () =>
      enableBodyScroll(iti.countryList)
    )
  })
}
